import { observable } from "mobx";
import { importService, secureService, settingService } from "../_services";
import i18n from 'i18next';
import { ILicense } from "../_types/interfaces";

const translate = (name: string) => i18n.t('setting.' + name);


export const secureStore = observable({
    isLoading: false,
    isNotification: false,
    code: "",
    codeServices: "",
    serverAddress: "",
    fullAddress: "",
    message: "",
    loadStatusInterval: null as any,
    loadStatus: false,
    licenseServices: [] as Array<ILicense>,
    showMessage(message: string) {
        secureStore.message = message;
        secureStore.isNotification = true;
    },
    async loadSecureInfo() {
        secureStore.isLoading = true;
        try {
            let response = await secureService.getCode();
            secureStore.code = response;
            response = await secureService.getServicesCode();
            secureStore.codeServices = response;
            response = await secureService.getServerAddress();
            secureStore.serverAddress = response;
            secureStore.fullAddress = secureStore.serverAddress + '/' + secureStore.code + '/' + secureStore.codeServices;
            const array_response = await secureService.getLicensesForServices();
            secureStore.licenseServices = array_response;
            
        }
        catch (errors) {
            secureStore.showMessage(translate('notification.load_error'));
        }
        secureStore.isLoading = false;
    },
    async importSecureFile(names: Array<File>) {
        secureStore.isLoading = true;
        try {
            const formData = new FormData();
            names.forEach(file => {
                formData.append("formFile", file);
            });
            await importService.importSecureFile(formData);
            this.loadStatusInterval = setInterval(() => this.checkLicenseLoadStatus(), 100) as any;
            
        }
        catch (errors) {
            console.log(errors);
            this.showMessage(translate('import_error'));
        }
        secureStore.isLoading = false;
    },

    async checkLicenseLoadStatus() {
        this.loadStatus = await importService.checkLicenseLoadStatus();
        if(this.loadStatus)
            return;
        clearInterval(this.loadStatusInterval);
        this.loadSecureInfo();
    },
})